/** Days before a contract's end date at which it is flagged "expiring soon" on the Contracts tab. */
export const ContractExpiryWarningDays = 30;
